import Cookies from 'universal-cookie'
import querystring from 'query-string'
import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

const DETAIL = createConstant('product/DETAIL')
const OTHER = createConstant('product/OTHER')
const LIKE_PRODUCT = createConstant('info/LIKE_PRODUCT')
const REPORT_PRODUCT = createConstant('info/REPORT_PRODUCT')

const cookies = new Cookies()
const initialState = {
  productDetailRequest: false,
  productDetailError: '',
  productDetail: undefined,
  otherRequest: false,
  otherError: '',
  other: undefined,
  likedProductsRequest: false,
  likedProductsError: '',
  likedProducts: [],
  reportedProductsSuccess: false,
  reportedProductsRequest: false,
  reportedProductsError: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DETAIL.request:
      return {
        ...state,
        productDetailRequest: true,
        productDetailError: '',
      }
    case DETAIL.failed:
      return {
        ...state,
        productDetailRequest: false,
        productDetailError: action.error.message,
        productDetail: undefined,
      }
    case DETAIL.success:
      return {
        ...state,
        productDetailRequest: false,
        productDetailError: '',
        productDetail: action.result.result,
      }
    case OTHER.request:
      return {
        ...state,
        otherRequest: true,
        otherError: '',
      }
    case OTHER.failed:
      return {
        ...state,
        otherRequest: false,
        otherError: action.error.message,
        other: undefined,
      }
    case OTHER.success:
      return {
        ...state,
        otherRequest: false,
        otherError: '',
        other: action.result.result,
      }
    case LIKE_PRODUCT.request:
      return {
        ...state,
        likedProductsRequest: true,
        likedProductsError: '',
      }
    case LIKE_PRODUCT.failed:
      return {
        ...state,
        likedProductsRequest: false,
        likedProductsError: action.error.message,
      }
    case LIKE_PRODUCT.success: {
      const { result, product } = action
      const likedProducts = state.likedProducts
      const newLikedProducts = !result.data ? likedProducts : [...likedProducts, product]

      return {
        ...state,
        likedProductsRequest: false,
        likedProducts: newLikedProducts,
      }
    }
    case REPORT_PRODUCT.request:
      return {
        ...state,
        reportedProductsRequest: true,
        reportedProductsError: '',
      }
    case REPORT_PRODUCT.failed:
      return {
        ...state,
        reportedProductsRequest: false,
        reportedProductsSuccess: false,
        reportedProductsError: action.error.errors,
      }
    case REPORT_PRODUCT.success: {
      return {
        ...state,
        reportedProductsSuccess: true,
        reportedProductsRequest: false,
      }
    }
    default:
      return state
  }
}

const opts = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getDetail = productSlug => ({
  types: DETAIL,
  promise: fetch(`${API_HOSTNAME}/v1/product/${productSlug}`, opts),
})

export const getOther = productSlug => ({
  types: OTHER,
  promise: fetch(`${API_HOSTNAME}/v1/product/${productSlug}/other`, opts),
})

export const likeProduct = (productSlug) => {
  const token = cookies.get('TKN_MINAPOLI')
  const likeOptions = {
    ...opts,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: querystring.stringify({ type: 'like' }),
  }

  return {
    types: LIKE_PRODUCT,
    product: productSlug,
    promise: fetch(`${API_HOSTNAME}/v1/product/${productSlug}/like`, likeOptions),
  }
}

export const reportProduct = (productSlug, message) => {
  const token = cookies.get('TKN_MINAPOLI')
  const reportOptions = {
    ...opts,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: querystring.stringify({ description: message }),
  }

  return {
    types: REPORT_PRODUCT,
    promise: fetch(`${API_HOSTNAME}/v1/product/${productSlug}/report`, reportOptions),
  }
}



// WEBPACK FOOTER //
// ./src/modules/Product/index.js